module.exports = __webpack_public_path__ + "img/operator.a3122d2e.png";